export const RESET_PASSWORD_FORM = "reset_password_form";
